// extracted by mini-css-extract-plugin
export var lg = "_jg-7";
export var md = "_jg-6";
export var placeholderContainer = "_jg-1";
export var placeholderIcon = "_jg-2";
export var productImage = "_jg-0";
export var sm = "_jg-5";
export var xl = "_jg-8";
export var xs = "_jg-4";
export var xxs = "_jg-3";